import React from "react";

export function SkeletonBlock({
  height = 16,
  width = "100%",
  radius = 10,
  style = {}
}) {
  return (
    <div
      className="skeleton-block"
      style={{
        height,
        width,
        borderRadius: radius,
        ...style
      }}
    />
  );
}

export function SkeletonCard({
  lines = 4,
  titleWidth = "40%"
}) {
  return (
    <div className="card">
      <SkeletonBlock height={22} width={titleWidth} radius={8} />
      <div style={{ marginTop: 14, display: "grid", gap: 10 }}>
        {Array.from({ length: lines }).map((_, index) => (
          <SkeletonBlock
            key={index}
            height={14}
            width={index === lines - 1 ? "70%" : "100%"}
          />
        ))}
      </div>
    </div>
  );
}

export function SkeletonTable({ rows = 5, cols = 5 }) {
  return (
    <div className="card">
      <div style={{ display: "grid", gap: 12 }}>
        <SkeletonBlock height={22} width="30%" radius={8} />
        <SkeletonBlock height={48} width="100%" radius={12} />

        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                {Array.from({ length: cols }).map((_, index) => (
                  <th key={index}>
                    <SkeletonBlock height={12} width="70%" />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: rows }).map((_, rowIndex) => (
                <tr key={rowIndex}>
                  {Array.from({ length: cols }).map((_, colIndex) => (
                    <td key={colIndex}>
                      <SkeletonBlock
                        height={14}
                        width={colIndex === 0 ? "90%" : "75%"}
                      />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}